import React from 'react';
import { Button } from '@mui/material';

// Shared style for page top action-bar ("toolbar") buttons so every tab looks
// the same. Dialog/Login buttons intentionally do NOT use this.
export const toolbarButtonSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 500,
  fontSize: '0.8125rem',
  textTransform: 'none',
  letterSpacing: '0.01em',
};

// Drop-in replacement for MUI <Button> in page toolbars. Defaults to size="small"
// and the shared style above; any sx passed by the caller is merged on top so
// per-button colors (e.g. borderColor) still work.
const ToolbarButton = ({ sx, size = 'small', ...props }) => (
  <Button size={size} sx={{ ...toolbarButtonSx, ...sx }} {...props} />
);

export default ToolbarButton;
